import React from 'react';
import { ActivityIndicator } from 'react-native';
import { TouchableOpacity, View } from "react-native-web";
import { TranslateText } from './translate-text';

const CustomButton = ({title, onPress, loading}:any) => {
  return (
    <View
      style={{
        marginVertical: 12,
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        flex: 1,
      }}
    >
        <TouchableOpacity
          onPress={onPress}
          style={{
            backgroundColor: "#33CF71",
            paddingVertical: 12,
            width: "90%",
            shadowColor: "#000",
            shadowOpacity: 0.5,
            shadowRadius: 12,
            borderRadius: 20,
            shadowOffset: { height: 4 },
          }}
        >
          {loading ? <ActivityIndicator/> : <View style={{ alignItems: "center" }}>
              <TranslateText style={{ color: "#FFF" }}>{title}
              </TranslateText>
          </View>}
        </TouchableOpacity>
      </View>
    );
};
  
export default CustomButton;